import { useCallback, useContext } from 'react';
import { convertEntities, getText, type TiptapOutputType } from '@amzn/awscat-editor';
import { AppContext } from '../../contexts/AppContext';

/**
 * Returns a pure function that converts a title to its plain-text form. For a
 * raw string, replaces APGL entity tokens with their display text using the
 * entity dictionary from AppContext. For a Tiptap output object, extracts the
 * already-rendered plain text.
 */
export function useEntityConverter(): (text: string | TiptapOutputType) => string {
  const appContext = useContext(AppContext);
  const entities = appContext?.entities;

  return useCallback(
    (text: string | TiptapOutputType) => {
      // For string, use the convertEntities(), which does not require creating
      // instances of editor plugins.
      if (typeof text === 'string') {
        return convertEntities(text, entities);
      }

      // For object from Tiptap output, use getText().
      // Less preferred since it is slower.
      return getText(text);
    },
    [entities],
  );
}
